var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.463 5.216a2.615 2.615 0 01-2.608-2.608A2.615 2.615 0 014.463 0C5.878 0 7.07 1.192 7.07 2.608a2.615 2.615 0 01-2.608 2.608zm0-4.88A2.242 2.242 0 002.227 2.57a2.242 2.242 0 002.236 2.235A2.242 2.242 0 006.698 2.57 2.242 2.242 0 004.463.335z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.524 8.867H.402a.205.205 0 01-.186-.112c-.932-2.608 1.453-3.95 1.49-3.986.074-.038.186 0 .26.074.038.075 0 .186-.074.26C1.818 5.142-.157 6.26.551 8.495h7.898c.708-2.235-1.267-3.353-1.341-3.39-.075-.037-.112-.15-.075-.26.038-.075.15-.113.261-.075.037 0 2.422 1.34 1.49 3.986-.111.074-.149.112-.26.112z",
    fill: "#898989"
  })));
}
SvgPlayers.displayName = 'Players';
export default SvgPlayers;